export const FILTER_OPTIONS = {
  all: 'All',
  active: 'Active',
  done: 'Done'
};
